import { Row } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	getSearchStringForBackNavigationWithBackText,
	nullSafeGet,
} from '../../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../../utils/DataConstants';
import { InvoiceRowDisplay } from '../../invoice_row_display/InvoiceRowDisplay';
import { getLinkWIthBackLinkParams } from '../../../utils/HistoryUtils';
import { getInvoiceSubUrl } from '../../invoice_utilities/InvoiceUtilities';

function InvoicesTableRow({
	location,
	record,
	userType,
	backText,
	selections,
	targetCollectionName,
	currentUser,
}) {
	const BACK_TEXT = backText || 'Back to invoices';
	const invoicePathName = getInvoiceSubUrl(userType, currentUser, record);

	const getLink = () => {
		const path = `/${invoicePathName}/detail/${nullSafeGet('id', record)}/details${
			targetCollectionName ? `?targetCollectionName=${targetCollectionName}` : ''
		}`;
		return getLinkWIthBackLinkParams(location, BACK_TEXT, path, {
			preserve: true,
		});
	};

	return (
		<Row>
			<Link to={getLink()} style={{ width: '100%' }}>
				<InvoiceRowDisplay invoice={record} currentUser={currentUser} />
			</Link>
		</Row>
	);
}

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesTableRow);
